<template>
    <el-card>
        <el-row>
            <div style="margin-bottom: 30px">
                <el-radio v-model="radio" label="1">{{ $t('transactionRecord.label.time') }}</el-radio>
                <el-radio v-model="radio" label="2">{{ $t('transactionRecord.label.orderNo') }}</el-radio>
            </div>
        </el-row>
        <!-- /* ---------------------------------- 搜索表单 ---------------------------------- */ -->
        <el-row v-if="radio === '1'">
            <el-form :inline="true" v-bind="formProps.form" :rules="{}">
                <el-form-item prop="formTime" :label="$t('orders.label.form.submitTime')">
                    <range-date-picker :need-init="true" ref="datePick" @showDateTime="(val)=>(formTime=val)" />
                </el-form-item>

                <el-form-item>
                    <el-button size="mini" type="primary" @click="handleSearch()">{{
                        $t('btns.search')
                        }}</el-button>
                </el-form-item>
            </el-form>
        </el-row>
        <!-- /* ---------------------------------- 搜索表单 ---------------------------------- */ -->
        <el-row v-if="radio === '2'">
            <el-form :model="form" v-bind="formProps.form">
                <el-form-item prop="systemOrderNo" :label="$t('transactionRecord.label.systemOrderNo')">
                    <el-input v-model="form.systemOrderNo" />
                </el-form-item>

                <el-form-item>
                    <el-button size="mini" type="warning" @click="handleEmpty()">{{
                        $t('btns.empty')
                        }}</el-button>
                    <el-button size="mini" type="primary" @click="handleSearch()">{{
                        $t('btns.search')
                        }}</el-button>
                </el-form-item>
            </el-form>
        </el-row>

        <!-- /* ---------------------------------- 表格数据 ---------------------------------- */ -->
        <el-row>
            <el-table :data="tableList" :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ textAlign: 'center' }" stripe>
                <el-table-column type="index" label="#" />
                <el-table-column width="200px" prop="systemOrderNo"
                    :label="$t('transactionRecord.label.systemOrderNo')">
                </el-table-column>
                <el-table-column prop="step" :label="$t('transactionRecord.label.step')" />

                <el-table-column prop="response" :label="$t('transactionRecord.label.response')">
                    <template slot-scope="{row}">
                        <el-popover placement="top" title="" :width="900" height="500px" trigger="click"
                            :content="row.response">
                            <el-button slot="reference" size="mini" type="info" >{{
                                $t('btns.detail')
                                }}</el-button>
                        </el-popover>
                    </template>
                </el-table-column>

                <!-- <el-table-column prop="step" :label="$t('transactionRecord.label.step')">
                    <template slot-scope="{row}">
                        <img v-if="row.qrCode" :src="row.qrCode" alt="pic" width="80">
                    </template>
                </el-table-column> -->

                <el-table-column prop="request" :label="$t('transactionRecord.label.callback')" />
                <el-table-column prop="params" :label="$t('transactionRecord.label.callbackParams')">
                    <template slot-scope="{row}">
                        <el-popover placement="top" title="" :width="500" trigger="click" :content="row.params">
                            <el-button v-if="row.params" slot="reference" size="mini" type="info"  @click="handleButtonClick(row.params)">{{ $t('btns.detail')
                                }}</el-button>
                        </el-popover>
                    </template>
                </el-table-column>

                <el-table-column width="200px" prop="message" :label="$t('transactionRecord.label.message')">
                    <!--          <template slot-scope="{ row }">-->
                    <!--            <el-popover-->
                    <!--              placement="top-start"-->
                    <!--              title=""-->
                    <!--              width="50%"-->
                    <!--              trigger="click"-->
                    <!--              :content="row.message"-->
                    <!--            >-->
                    <!--              <el-button slot="reference" size="mini" type="info">{{-->
                    <!--                $t('btns.detail')-->
                    <!--              }}</el-button>-->
                    <!--            </el-popover>-->
                    <!--          </template>-->
                </el-table-column>

                <el-table-column width="200px" prop="createTime" :label="$t('transactionRecord.label.createTime')">
                    <template slot-scope="{ row }">
                        {{ row.createTime | asDayjs }}
                    </template>
                </el-table-column>
                <el-table-column prop="timeline" :label="$t('transactionRecord.label.timeline')">
                </el-table-column>
            </el-table>
        </el-row>

        <!-- /* ----------------------------------- 分页 ----------------------------------- */ -->
        <v-pagination v-if="this.radio === '1'" v-model="pagination" :total="tableData.rows" @update="getTableData" />
    </el-card>
</template>

<script>
    import transactionRecordApi from '@/api/transactionRecord';
    import { debounce } from 'lodash';
    import RangeDatePicker from "../cuscom/range-date-picker.vue";
    import { isJsonString } from "../../utils";
    export default {
        name: 'transactionRecord',
        components: { RangeDatePicker },
        data() {
            return {
                formTime: [],
                form: {
                    systemOrderNo: ''
                },
                radio: '1',
                pagination: {
                    no: 1,
                    size: this.$defaultPaginationSize
                },
                tableData: {},
                tableList1: []
            };
        },
        computed: {
            tableList() {
                if (this.radio === '1') {
                    return this.tableData.list || [];
                } else {
                    return this.tableList1 || [];
                }
            }
        },
        created() {
            this.init();
        },
        watch: {},
        mounted() {
            this.getTableData();
        },
        activated() {
            this.searchSys();
        },
        methods: {
            init() {
                this.handleSearch = debounce(this._handleSearch, 200);
                this.formProps = {
                    form: {
                        ref: 'form',
                        inline: true,
                        size: 'small',
                        rules: {
                            systemOrderNo: [
                                {
                                    required: true,
                                    message: this.$t('transaction.rules.systemOrderNo')
                                }
                            ]
                        }
                    }
                };
            },

            /* ------------------------------ 判断是否商户订单跳转过来的 ----------------------------- */
            async searchSys() {
                if (this.$route.query.systemOrderNo) {
                    this.radio = '2';
                    this.form.systemOrderNo = this.$route.query.systemOrderNo;
                    const params = {
                        ...this.form
                    };
                    const { data } = await transactionRecordApi.getSearch(params);
                    if (data && data.code === 200) {
                        this.tableList1 = data.data;
                    } else {
                        this.$message.error(data.msg);
                    }
                }
            },

            /* ---------------------------------- 格式化数据 --------------------------------- */
            formatParams() {
                const [transactionBeginTime, transactionEndTime] = this.formTime;
                if (!transactionBeginTime || !transactionEndTime) {
                    // 若用户点击了时间表单的清空，则重新默认选择当天数据
                    this.$refs.datePick.handleTime('today');
                }
                return {
                    transactionBeginTime: transactionBeginTime,
                    transactionEndTime: transactionEndTime
                };
            },

            /* --------------------------------- 请求表格数据 --------------------------------- */
            async getTableData() {
                console.log(this.pagination);
                const { data } = await transactionRecordApi.getPage({
                    data: this.formatParams(),
                    params: this.pagination
                });
                if (data && data.code === 200) {
                    this.tableData = data.data || {};
                    this.tableData.list = this.tableData.list.map((item) => {
                        let objStr = ''
                        if (item.response) {
                            objStr = item.response.replace('success -> ', '')
                        }
                        return {
                            ...item,
                            qrCode: objStr !== '' ? isJsonString(objStr) ? JSON.parse(objStr).data.qrCode : '' : ''
                        }
                    })
                    console.log('我擦。。好不好搞。。。', this.tableData.list)
                } else {
                    this.$message.error(data.msg);
                }
            },

            /* --------------------------------- 事件驱动函数 --------------------------------- */
            handleEmpty() {
                this.form = {
                    systemOrderNo: ''
                };
                // this.$refs.datePick.handleTime('today')
            },
            async _handleSearch() {
                console.log(3333);
                if (this.radio === '1') {
                    this.getTableData();
                } else {
                    this.$refs.form.validate(async (valid) => {
                        if (valid) {
                            const params = {
                                ...this.form
                            };
                            const { data } = await transactionRecordApi.getSearch(params);
                            if (data && data.code === 200) {
                                this.tableList1 = data.data;
                            } else {
                                this.$message.error(data.msg);
                            }
                        }
                    });
                }
            },
            handleButtonClick(params) {
                console.log('row.params***************',params);
            }
        }
    };
</script>

<style lang="scss" scoped>
    >>>.el-table th {
        overflow: visible;

        .cell {
            white-space: nowrap;
            text-overflow: clip;
            overflow: visible;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/transactionRecord/index.vue